export default __webpack_public_path__ + "b3be1cd0085a6ccf6bbeda873907251c.png";